/* eslint-disable no-use-before-define */
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';
import PropType from 'prop-types';
import { InputAdornment } from '@mui/material';
import NInput from './NInput';

function NSearch(props) {
  const { onChange, value } = props;

  return (
    <div>
      <NInput
        className='!bg-white xxl:!w-[373px]'
        placeholder='Search'
        type='text'
        value={value}
        onChange={onChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon className='text-gray-200' />
            </InputAdornment>
          ),
        }}
        {...props}
      />
    </div>
  );
}

NSearch.propTypes = {
  onChange: PropType.func,
  value: PropType.string,
};

NSearch.defaultProps = {
  onChange: undefined,
  value: undefined,
};

export default NSearch;
